import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error.response?.status === 404) return false;
        return failureCount < 2;
      },
      cacheTime: 10 * 60 * 1000,
    },
    mutations: {
      retry: 1,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error('Global query error:', error);
      // Add safe error logging to prevent accessing undefined properties
      const errorMessage = error?.message || error?.response?.data?.message || 'Unknown error';
      console.error('Query:', query?.queryKey, 'Error:', errorMessage);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, variables, context, mutation) => {
      console.error('Global mutation error:', error);
      // Add safe error logging to prevent accessing undefined properties
      const errorMessage = error?.message || error?.response?.data?.message || 'Unknown mutation error';
      console.error('Mutation:', mutation?.options?.mutationKey, 'Error:', errorMessage);
    },
  }),
});